import { getInventoryEntrypointData } from '@app/api/inventory.api';
import { IErrorData } from '@app/interfaces/apiError';
import { IInventoryType, IPopulatedInventory } from '@app/interfaces/inventory';
import { IUser } from '@app/interfaces/user';
import { IPopulatedWaterbody } from '@app/interfaces/waterbody';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

export interface IState {
  loading: boolean;
  waterbodies: IPopulatedWaterbody[];
  types: IInventoryType[];
  inventories: IPopulatedInventory[];
  employees: IUser[];
}

export const initialState = {
  loading: false,
  waterbodies: [],
  types: [],
  inventories: [],
  employees: [],
} as IState;

const slice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryData.pending, (state: IState) => ({
        ...state,
        loading: true,
      }))
      .addCase(
        fetchInventoryData.fulfilled,
        (
          state: IState,
          {
            payload,
          }: {
            payload: {
              waterbodies: IPopulatedWaterbody[];
              types: IInventoryType[];
              inventories: IPopulatedInventory[];
              employees: IUser[];
            };
          },
        ) => ({
          ...state,
          loading: false,
          waterbodies: payload.waterbodies,
          types: payload.types,
          inventories: payload.inventories,
          employees: payload.employees,
        }),
      );
  },
});

export const fetchInventoryData = createAsyncThunk(
  'inventory/fetchInventoryData',
  async (_: undefined, { rejectWithValue }) => {
    try {
      const reponse = await getInventoryEntrypointData();

      const waterbodies = reponse.data.waterbodies as IPopulatedWaterbody[];
      const types = reponse.data.types;
      const inventories = reponse.data.inventories;
      const employees = reponse.data.employees;

      return { waterbodies, types, inventories, employees };
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err.response?.data as IErrorData);
    }
  },
);

export const inventory = slice.reducer;
